A possible response to an `ApplicationQuestion`.
